import * as Scrivito from "scrivito";

const SelectOptionWidget = Scrivito.provideWidgetClass("SelectOptionWidget", {
  attributes: {
    text: "string",
    value: "string",
  },
  onlyInside: "SelectboxWidget",
});

export default SelectOptionWidget;
